import React, { useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../navigation/TemporaryUserInfo';
import LoginController from '../controller/LoginController';
import styled from 'styled-components';

export const ChangePassword = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordCheck, setNewPasswordCheck] = useState('');
  const [errorBorder, setErrorBorder] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const oAuthContext = useContext(AuthContext);

  const oldPwOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOldPassword(e.target.value);
  };
  const newPwOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewPassword(e.target.value);
  };
  const newPwCheckOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewPasswordCheck(e.target.value);
  };

  const changePassword = async () => {
    if (oldPassword === '') {
      setErrorMessage('기존 비밀번호를 입력해주세요.');
      setErrorBorder(false);
    } else if (newPassword === '') {
      setErrorMessage('변경하려는 비밀번호를 입력해주세요.');
      setErrorBorder(false);
    } else if (newPasswordCheck === '') {
      setErrorMessage('변경하려는 비밀번호를 한번 더 입력해주세요.');
      setErrorBorder(false);
    } else if (newPassword !== newPasswordCheck) {
      setErrorMessage('변경하려는 비밀번호가 일치하지 않습니다.');
      setErrorBorder(false);
    } else {
      try {
        const oData = {
          old_password: oldPassword,
          new_password: newPassword,
        };
        let oRes = await LoginController.changePassword(oData);
        console.log('oRes.data---->', oRes.data);
        if (oRes.data && oRes.data.ok) {
          alert('비밀번호가 변경되었습니다. 다시 로그인해주세요.');
          logout();
        } else {
          setErrorMessage('현재 비밀번호가 올바르지 않습니다. 다시 확인하고 입력해주세요 ');
          setErrorBorder(false);
        }
      } catch (error) {
        console.error('changePassword error:', error);
        return false;
      }
    }
  };

  // enter로 비밀번호 변경
  const handleEnterKey = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        changePassword();
      }
    },
    [changePassword],
  );

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <div className="loginWrap">
            <div>
              <h1 className="logo">INVISIBLEIDEAS</h1>
              <h1 className="title">비밀번호 변경하기</h1>

              <div className="loginForm">
                <label htmlFor="password">기존 비밀번호</label>
                <input
                  type="password"
                  name="password"
                  placeholder="기존 비밀번호를 입력해 주세요."
                  value={oldPassword}
                  onChange={oldPwOnChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                />
              </div>
              <div className="loginForm">
                <label htmlFor="password">새 비밀번호</label>
                <input
                  type="password"
                  name="password"
                  placeholder="변경할 비밀번호를 입력해 주세요."
                  value={newPassword}
                  onChange={newPwOnChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                  onKeyDown={handleEnterKey}
                />
              </div>
              <div className="loginForm">
                <label htmlFor="password">새 비밀번호 확인</label>
                <input
                  type="password"
                  name="password"
                  placeholder="변경할 비밀번호를 한번 더 입력해 주세요."
                  value={newPasswordCheck}
                  onChange={newPwCheckOnChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                  onKeyDown={handleEnterKey}
                />
              </div>
            </div>
            {!errorBorder && (
              <div className="errorMessage">
                <p>{errorMessage}</p>
              </div>
            )}
            <button className="loginButton" onClick={changePassword}>
              <p>비밀번호 변경</p>
            </button>
          </div>
          <button onClick={() => navigate('/dashboard')} className="moveLogin">
            <p>비밀번호 변경하지 않기</p>
          </button>
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  .wrap {
    width: 100%;
    height: 100vh;
    background: #f8fafc;
    display: flex;
    align-items: center;
  }
  .container {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    height: 60vh;
    padding: 48px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
  }
  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #26282c;
  }
  button,
  label,
  label > input {
    cursor: pointer;
  }

  .logo {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
  }
  .title {
    text-align: center;
    font-size: 20px;
    margin-top: 10px;
    margin-bottom: 32px;
    color: #333;
  }
  .loginWrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .loginForm {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    label {
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #4f5459;
    }
    input {
      padding: 10px 14px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      outline: none;
    }
  }
  .formCheckbox {
    width: 100%;
    display: flex;
    justify-content: space-between;

    label {
      display: flex;
      font-size: 16px;
      font-weight: 600;
      align-items: center;
      color: #344054;
    }
    input {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .loginFind {
    button {
      margin-left: 16px;
      padding: 0;
      border: none;
      background: none;
      outline: none;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #72727e;
      }
    }
  }

  /* errorMessage */
  .errorMessage {
    width: 100%;

    p {
      margin: 6px 0 0 0;
      font-size: 16px;
      font-weight: 700;
      color: #f04438;
    }
  }

  /* 로그인 버튼 */
  .loginButton {
    width: 100%;
    margin-top: auto;
    margin: 12px 0 0 0;
    background: #26282c;
    border-radius: 8px;
    border: none;
    outline: none;

    p {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }
  }

  /* moveLogin */
  .moveLogin {
    margin-top: 10px;
    background: none;
    border: none;
    outline: none;

    p {
      font-size: 13px;
      font-weight: 400;
      text-decoration: underline;
      text-underline-offset: 4px;
    }
  }
`;
